import { gql } from '@apollo/client';

export const CANCEL_BOOK_CONTRACT = gql`
	mutation CancelContractRequest($bookId: String!) {
		request: cancelContractRequest(bookId: $bookId) {
			contract_status
		}
	}
`;